import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

const TOKEN_KEY = 'lda_auth_token';

// 受保护的路由组件
function ProtectedRoute({ children }) {
  const token = localStorage.getItem(TOKEN_KEY);
  
  if (!token) {
    // 未登录，重定向到登录页
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

function RouterApp() {
  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        } 
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default RouterApp;
